// extracted by mini-css-extract-plugin
export default {"label":"Label_label__62ZNF","required":"Label_required__-ifny","labelSmall":"Label_labelSmall__uU2WK","labelLarge":"Label_labelLarge__lpWoz"};